(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-youtube"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function(){ 
   
        $(".youtube").magnificPopup({
            type: 'iframe',
            gallery: {
                enabled: true
            }
        });
  
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-faq"]) return;
  try {
    


 // acordion
  const items = document.querySelectorAll(".accordion button");
	const itemsWrapp = document.querySelectorAll(".accordion-item");
        function toggleAccordion() {
          const itemToggle = this.getAttribute('aria-expanded');
		  const itemWrapToggle = this.closest("div").getAttribute('aria-open');
          for (i = 0; i < items.length; i++) {
            items[i].setAttribute('aria-expanded', 'false');
            itemsWrapp[i].setAttribute('aria-open', 'false');
          }

          if (itemToggle == 'false') {
            this.setAttribute('aria-expanded', 'true');
            this.closest("div").setAttribute('aria-open', 'true');
          }
        }

   items.forEach(item => item.addEventListener('click', toggleAccordion)); 



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-free-yes-no"]) return;
  try {
    

	document.addEventListener('DOMContentLoaded', function(){ 
   
          $(".youtube").magnificPopup({
              type: 'iframe',
              gallery: {
                  enabled: true
              }
          });

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-free"]) return;
  try {
    

	document.addEventListener('DOMContentLoaded', function(){ 
   
          $(".youtube").magnificPopup({
              type: 'iframe',
              gallery: {
                  enabled: true
              }
          });

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-live-demo"]) return;
  try {
    

	document.addEventListener('DOMContentLoaded', function(){ 
   
          $(".youtube").magnificPopup({
              type: 'iframe',
              gallery: {
                  enabled: true
              }
          });

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-press"]) return;
  try {
    


 // acordion
  const items = document.querySelectorAll(".accordion button");
	const itemsWrapp = document.querySelectorAll(".accordion-item");
        function toggleAccordion() {
          const itemToggle = this.getAttribute('aria-expanded');
		  const itemWrapToggle = this.closest("div").getAttribute('aria-open');
          for (i = 0; i < items.length; i++) {
            items[i].setAttribute('aria-expanded', 'false');
            itemsWrapp[i].setAttribute('aria-open', 'false');
          }

          if (itemToggle == 'false') {
            this.setAttribute('aria-expanded', 'true');
            this.closest("div").setAttribute('aria-open', 'true');
          }
        }

   items.forEach(item => item.addEventListener('click', toggleAccordion)); 



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-testimonials"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function(){ 
   
        $(".youtube").magnificPopup({
            type: 'iframe',
            gallery: {
                enabled: true
            }
        });
  
});



  } catch(e) { console.error(e); }
})();
})();
